<template>
    <div>
        <public-title showBack>红包节省列表</public-title>
        <div class="bg-white p-4">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="全部" name="0" />
                <el-tab-pane label="住宿订单" name="3" />
                <el-tab-pane label="民宿订单" name="5" />
                <el-tab-pane label="景区订单" name="6" />
                <el-tab-pane label="度假产品" name="7" />
            </el-tabs>
            <div class="d-flex d-center-between mt-4 mb-4">
                <div class="w-35">
                    <left-text-border leftText="订单号" v-model="order_no" />
                </div>
                <div class="w-35">
                    <left-text-border leftText="团号" v-model="title" />
                </div>
                <div class="text-link" @click="getSaveLists">搜索</div>
            </div>
            <el-table :data="lists"  class="w-100 mt-2" v-if="lists.length > 0">
                <el-table-column  label="团号/类型">
                    <template slot-scope="scope">
                        <div class="text-muted">{{scope.row.title}}</div>
                        <div class="text-muted">{{scope.row.style | formatVar('OrderStyle')}}</div>
                    </template>
                </el-table-column>
                <el-table-column  label="使用时间">
                    <template slot-scope="scope"><span class="text-muted">{{scope.row.used_time | formatTimestamp(1)}}</span></template>
                </el-table-column>
                <el-table-column  label="应付金额">
                    <template slot-scope="scope">&yen;{{scope.row.price}}</template>
                </el-table-column>
                <el-table-column  label="通用红包">
                    <template slot-scope="scope"><span class="text-warning">- &yen;0.00</span></template>
                </el-table-column>
                <el-table-column  label="专属红包">
                    <template slot-scope="scope"><span class="text-warning">- &yen;{{scope.row.money}}</span></template>
                </el-table-column>
                <el-table-column  label="实付金额">
                    <template slot-scope="scope" class="text-warning">&yen;{{scope.row.pay}}</template>
                </el-table-column>
                <el-table-column  label="订单状态">
                    <template slot-scope="scope">
                        <span :class="['ml-2',$GFUN.FormatColor(scope.row.status)]">{{scope.row.status | formatVar('HOrderStatus')}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                    <span class="text-link" @click="goDetail(scope.row)">查看详情</span>
                    </template>
                </el-table-column>
            </el-table>
            <div v-else class="mt-5">暂无数据</div>
            <el-pagination background layout="prev, pager, next" class="mt-4"
                v-if="lists.length > 0" :total="total" :current-page=page :page-size="10"
                @current-change="v => {this.page=v;this.getSaveLists()}" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'SaveList',
    data (){
        return {
            activeName: 0,
            order_no: '',
            title: '',
            lists: [],
            page: 1,
            total: 1
        }
    },
    created () {
        this.getSaveLists()
    },
    methods: {
        handleClick () { this.getSaveLists() },
        goDetail (item) {
            let routeUrl = this.$router.resolve({
            name: 'OrderDetail',
            query: {
                orderType: item.style,
                orderId: item.oid,
                status: item.status
            }
            });
            window.open(routeUrl.href, '_blank');
        },
        async getSaveLists() {
            let resData = await this.$axios.post('/pc/Admin/getRedPacketEconomizeDetail', {
                uid: this.$route.query.uid,
                style: this.activeName,
                order_no: this.order_no,
                title: this.title,
                page: this.page,
                num: 10
            });
            if (resData.code === '00000' || resData.code == '99999') {
                this.lists = resData.data || []
                this.total = resData.count || 0
            }
        }
    }
}
</script>